import React from 'react';

const FooterCustom: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};

export default FooterCustom;
